import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import _ from "lodash";
import ReactPaginate from "react-paginate";

function MasterIntentList(props) {
  const [IntentList, setIntentList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [paginatedPosts, setpaginatedPosts] = useState();

  const navigate = useHistory();
  const pageSize = 10;
  // const history=useHistory();
  const PtId = localStorage.getItem("PatQusId");

  useEffect(() => {
    LoadIntents();
  }, [pageSize]);

  const LoadIntents = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/GetAllMasterIntent`)
      .then((res) => {
        //console.log("list", res.data)
        setIntentList(res.data);
        setpaginatedPosts(_(res.data).slice(0).take(pageSize).value());
      });
    localStorage.removeItem("PortalStatus");
  };
  const pageCount = IntentList ? Math.ceil(IntentList.length / pageSize) : 0;
  if (pageCount === 1) return null;
  const pages = _.range(1, pageCount + 1);

  const handlePageClick = async (data) => {
    // //console.log("pageno", data.selected + 1)
    let currentPage = data.selected + 1;
    setCurrentPage(currentPage);
    const startIndex = (currentPage - 1) * pageSize;
    const paginatedPost = _(IntentList)
      .slice(startIndex)
      .take(pageSize)
      .value();
    setpaginatedPosts(paginatedPost);
  };

  const EditIntents = (valid) => {
    localStorage.setItem("IntentInfo", valid);

    //console.log("the vaue", valid)
  };
  const deleteIntent = (value) => {
    //console.log("the vaue", value)

    const datavalue = {
      id: value,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/DeleteIntents`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions)
      .then((res) => {
        //console.log("get value", res);
        //console.log("success")
        Swal.fire({
          title: "Success",
          text: "Deleted successfully",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(function () {
          window.location.reload(true);
        });
      })
      .catch((error) => {
        //console.log("error occur", error);
      });
  };
  const BackFunc = () => {
    navigate.push("/index");
  };
  return (
    <>
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title">List of Intents</div>
              </div>
              <div className=" pull-right">
                <button
                  type="submit"
                  className="btn btn-primary d-inline-block"
                  onClick={BackFunc}
                >
                  {" "}
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    {/* <div className="card-head">
                                            <header>Intents List</header>
                                            <div className="tools">
                                               
                                            </div>
                                        </div> */}
                    <div className="card-body ">
                      <div className="table-responsive">
                        <table className="table table-striped custom-table table-hover">
                          <thead>
                            <tr>
                              <th>Intents</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {paginatedPosts &&
                              paginatedPosts.length > 0 &&
                              paginatedPosts.map((item) => (
                                <tr>
                                  <td>
                                    <a href="#">{item.intents}</a>
                                  </td>
                                  <td>
                                    <Link
                                      to="/UpdateMasterIntent"
                                      onClick={() => EditIntents(item.id)}
                                      className="btn btn-primary btn-xs py-2"
                                    >
                                      <i className="fa fa-pencil"></i>
                                    </Link>

                                    <button
                                      className="btn btn-danger btn-xs py-2"
                                      onClick={() => deleteIntent(item.id)}
                                    >
                                      <i className="fa fa-trash-o "></i>
                                    </button>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                      <ReactPaginate
                        previousLabel={"Prev"}
                        nextLabel={"Next"}
                        breakLabel={"..."}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={3}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination justify-content-center"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        previousClassName={"page-item"}
                        previousLinkClassName={"page-link"}
                        nextClassName={"page-item"}
                        nextLinkClassName={"page-link"}
                        breakClassName={"page-item"}
                        breakLinkClassName={"page-link"}
                        activeClassName={"active"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MasterIntentList;
